import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ib-title summary-section flex-row flex-justify-sb" }
const _hoisted_2 = { id: "summaryStatusText" }
const _hoisted_3 = {
  class: "summary-section",
  id: "orderItems"
}
const _hoisted_4 = {
  key: 0,
  class: "summary-section summary-totals bar-top"
}
const _hoisted_5 = { class: "summary-section summary-totals" }
const _hoisted_6 = {
  key: 0,
  class: "summary-line flex-row flex-justify-sb"
}
const _hoisted_7 = { class: "summary-line flex-row flex-justify-sb" }
const _hoisted_8 = { class: "summary-line flex-row flex-justify-sb" }
const _hoisted_9 = { id: "feeBreakdown" }
const _hoisted_10 = {
  key: 0,
  class: "fee-breakdown"
}
const _hoisted_11 = {
  key: 1,
  class: "flex center v-center",
  style: {"height":"25px"}
}
const _hoisted_12 = {
  key: 2,
  class: "summary-line flex-row flex-justify-sb fw-heavy summary-balance"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cart_item = _resolveComponent("cart-item")!
  const _component_gift_card_payment = _resolveComponent("gift-card-payment")!
  const _component_cart_promo = _resolveComponent("cart-promo")!
  const _component_currency = _resolveComponent("currency")!
  const _component_loader_display = _resolveComponent("loader-display")!

  return (_openBlock(), _createElementBlock("div", {
    id: "orderSummary",
    class: _normalizeClass(["info-box flex-col", _ctx.orderStatus])
  }, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "order-status-color" }, null, -1)),
    _createElementVNode("span", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Order Summary", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.orderStatus), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_cart_item, {
          key: item.OrderEntityKey,
          item: item
        }, null, 8, ["item"]))
      }), 128))
    ]),
    (!_ctx.isLoading && _ctx.activeOrder.paymentDue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "action-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGiftCard = !_ctx.openGiftCard))
          }, "Apply gift card"),
          _createElementVNode("div", {
            class: _normalizeClass(["gc-entry", { open: _ctx.openGiftCard }])
          }, [
            _createVNode(_component_gift_card_payment)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.activeOrder.paymentDue)
      ? (_openBlock(), _createBlock(_component_cart_promo, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.activeOrder.discountTotal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Discounts", -1)),
            _createElementVNode("span", null, [
              _cache[2] || (_cache[2] = _createTextVNode("-", -1)),
              _createVNode(_component_currency, {
                amount: _ctx.activeOrder.discountTotal
              }, null, 8, ["amount"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Subtotal", -1)),
        _createElementVNode("span", null, [
          _createVNode(_component_currency, {
            amount: _ctx.activeOrder.subtotal
          }, null, 8, ["amount"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Taxes & Fees", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, [
            _createVNode(_component_currency, { amount: _ctx.feesTotal }, null, 8, ["amount"])
          ]),
          (_ctx.feesTotal > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fw-medium" }, "Taxes & Fees", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOrder.fees, (fee) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex-row flex-justify-sb",
                    key: fee.FeeKey
                  }, [
                    _createElementVNode("span", null, _toDisplayString(fee.FeeName), 1),
                    _createVNode(_component_currency, {
                      amount: fee.Amount
                    }, null, 8, ["amount"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_loader_display, { small: true })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Balance Due", -1)),
            _createElementVNode("span", null, [
              _createVNode(_component_currency, { amount: _ctx.balanceDue }, null, 8, ["amount"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}